
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ApiMockPluginsManagerService } from '@bp/shared/services';

import { CurrentMerchantSubscriptionEffects } from './state/current-merchant-subscription.effects';
import { FEATURE_KEY, reducer } from './state/current-merchant-subscription.reducer';

@NgModule({
	imports: [
		StoreModule.forFeature(FEATURE_KEY, reducer),
		EffectsModule.forFeature([ CurrentMerchantSubscriptionEffects ]),
	],
})
export class MerchantAdminDomainsCurrentMerchantSubscriptionRootModule {

	constructor(private readonly _apiMocksManagerService: ApiMockPluginsManagerService) {
		void this._apiMocksManagerService.register(
			async () => import('./api-mock-plugin/current-merchant-subscription-api-mock-plugin'),
		);
	}

}
